"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorCollectionFieldView = exports.CSS = void 0;
var tslib_1 = require("tslib");
var IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
var core_shared_1 = require("@ikegps/core-shared");
var collection_title_1 = require("../../../components/collection/collection.title");
var input_1 = require("../../../components/input/input");
var spinner_1 = require("../../../components/spinner/spinner");
var theme_1 = require("../../../components/theme");
var index_1 = require("../../../i18n/index");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var store_1 = require("../../../store");
var capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
var field_info_1 = require("../../field.info/field.info");
exports.CSS = {
    capture: 'c-Vector__capture'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.capture] = {
        padding: theme_1.DefaultTheme.space(1)
    },
    _a));
function viewTopLevelCaptures(collection) {
    var imageCtx = { truesize: true, className: exports.CSS.capture };
    var nodes = [];
    for (var _i = 0, _a = collection.schema.fields; _i < _a.length; _i++) {
        var formField = _a[_i];
        var field = collection.getField(formField.id);
        if (!IkeModel.CollectionModelFieldTrueSize.isTrueSizeField(field) || !field.hasValue()) {
            continue;
        }
        var captures = field.getCaptures();
        for (var _b = 0, captures_1 = captures; _b < captures_1.length; _b++) {
            var capture = captures_1[_b];
            imageCtx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            nodes.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, imageCtx));
        }
    }
    return nodes;
}
exports.VectorCollectionFieldView = {
    viewInline: function (field, ctrl) {
        var targetCollections = field.getCollections();
        if (targetCollections == null || targetCollections[0] == null) {
            return (0, mithril_1.m)('span', (0, index_1.Translate)(index_1.T.UNKNOWN));
        }
        var targetCollection = store_1.AppStore.CollectionSummary.getLatest(targetCollections[0].revision) || targetCollections[0];
        var titleNode;
        var vectorValue = field.value;
        if (ctrl.canInspectCollection(targetCollection)) {
            titleNode = (0, mithril_1.m)('a', {
                title: (0, index_1.Translate)(index_1.T.COLLECTION_EDIT),
                onclick: function () {
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:navigate', field.schema.displayName, 1);
                    ctrl.inspectCollection(targetCollection.revision);
                }
            }, collection_title_1.CollectionTitle.view(targetCollection.title));
            vectorValue = core_shared_1.IkeGeodesic.getVector(field.collection.location, store_1.AppStore.Collection.get(targetCollection.revision).location);
        }
        else {
            titleNode = collection_title_1.CollectionTitle.view(targetCollection.title);
        }
        var onmouseover = function () {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        var onmouseout = function () {
            page_state_1.CurrentState.setHoverId(null);
        };
        var className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover, onmouseout: onmouseout, onclick: onclick }, [
            (0, mithril_1.m)('span', [
                field_info_1.FieldInfo.viewVectorInline(vectorValue),
                ' - ',
                titleNode
            ])
        ]);
    },
    hasDetail: function (field) {
        return true;
    },
    viewDetail: function (field) {
        var targetCollections = field.getCollections();
        if (targetCollections == null || targetCollections[0] == null) {
            return null;
        }
        var targetCollection = targetCollections[0];
        var targetCollectionModel = store_1.AppStore.Collection.get(targetCollection.revision);
        if (targetCollectionModel == null) {
            return spinner_1.Spinner.view();
        }
        var captureNodes = viewTopLevelCaptures(targetCollectionModel);
        if (captureNodes.length === 0) {
            return (0, mithril_1.m)('span', (0, index_1.Translate)(index_1.T.NO_CAPTURES));
        }
        return mithril_1.m.fragment({}, captureNodes);
    },
    viewEdit: function (field, ctrl) {
        return exports.VectorCollectionFieldView.viewInline(field, ctrl);
    }
};
//# sourceMappingURL=vector.collection.field.view.js.map